import accessibleAutocomplete from 'accessible-autocomplete'

import { scrollToTarget } from "./utils/scrollToTarget";
import qs from 'qs'
import IMask from "imask";

class InternetAvailability {
    constructor(element) {
        this.element = element
        this.container = this.element.querySelector('.form__wrapper')
        this.form = this.element.getElementsByTagName('FORM')[0]
        this.submitButton = this.form.querySelector('button[type=submit]')
        this.offers = this.element.querySelector('.internet-availability-check__offers-wrap')
        this.otoIdField = this.element.querySelector('#internet__oto-id-field')
        this.otoId = null
        this.cities = []
        this.addressFieldContainer = this.element.querySelector('#internet__address-field-container')
        this.addressField = null
        this.cleanAddress = null
        this.numberField = this.element.querySelector('#internet__number-field')
        this.citiesSelectField = this.element.querySelector('#internet__city')
        this.selectedCity = null
        this.formSubmittable = true
        this.data = {}

        this.responseBlock = this.element.querySelector('[data-response-block]')
        this.feedbackBlock = this.element.querySelector('[data-feedback-block]')
        this.summaryBlock = this.element.querySelector('[data-summary-block]')

        this.init()
        this.formInit()
        this.bindFormResetAction()
    }


    init() {
        this.autoCompleteInit()
        this.numberMaskInit()

        this.getCities().then(response => {
            this.cities = [...new Map(response.filter(item => !['St. Niklausen', 'Littau'].includes(item.name)).map(item => [item.name, item])).values()]
            this.citiesSelectField.insertAdjacentHTML(
                'beforeend',
                `${this.cities.map(city => {
                    return `<option value="${city.name}">${city.name}</option>`
                }).join('')}`)

            this.selectedCity = this.cities[0].name
            this.selectInit()
        })



    }

    numberMaskInit() {
        const mask = IMask(this.otoIdField, {
            mask: 'a{.}000{.}000{.}000[{.}0]',
            definitions: {
                'a': /[a-zA-Z]/
            }
        })

        this.otoIdField.addEventListener('keyup', event => {
            this.otoIdField.value = this.otoIdField.value.toUpperCase();
            mask.updateValue()
        });
    }

    autoCompleteInit() {
        const suggest = (query, populateResults) => {

            fetch(
                `/actions/fibx/address/autocomplete-street-address?streetname=${query.trim()}&city=${this.selectedCity}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            ).then(response => {
                return response.json();
            }).then(result => {
                return populateResults([...new Set(result.data.map(item => `${item.streetname}`))])
            })

        }

        accessibleAutocomplete({
            element: this.addressFieldContainer,
            id: 'internet__address-field', // To match it to the existing <label>.
            source: suggest,
            minLength: 1,
            displayMenu: 'overlay',
            tNoResults: () => this.element.dataset.errorMessage,
            onConfirm: (val) => {
                if (!val) {
                    return
                }

                this.selectedAddress = val
            }
        })

        this.addressField = this.element.querySelector('#internet__address-field')
        this.addressField.setAttribute('required', true)
    }


    getCities() {
        return new Promise(resolve => {
            fetch(
                '/actions/fibx/address/city',
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            ).then(response => {
                return response.json();
            }).then(result => {
                resolve(result.data)
            })
        })
    }


    formInit() {
        this.form.addEventListener('submit', (evt) => {
            evt.preventDefault()

            if (!this.formSubmittable) {
                return
            }

            // add loading
            this.formSubmittable = false
            this.submitButton.classList.add('loading')

            this.otoId = this.otoIdField.value.trim()

            const data = {
                streetname: this.addressField.value.trim(),
                city: this.selectedCity,
                // country: 'Schweiz',
                ...this.splitHouseNumber(this.numberField.value.trim()),
                otoid: this.otoId,
                otoport: 1
            }

            fetch(
                `/actions/fibx/availability/check?${qs.stringify(data)}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ).then(response => {
                return response.json();
            }).then(result => {
                this.handleResponse(result)
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                // add remove loading
                this.submitButton.classList.remove('loading')
                this.form.dispatchEvent(new Event("internetAvailabilitySubmit"))
                scrollToTarget(this.element, 150)
            })

        })

    }

    bindFormResetAction() {
        const shutdownReset = this.element.querySelector('#form__reset-action')
        shutdownReset.addEventListener('click', () => {
            this.otoIdField.value = null
            this.addressField.value = null
            this.selectedAddress = null
            this.numberField.value = null
            this.formSubmittable = true
            this.cleanAddress = null

            this.form.classList.remove('hide')
            this.responseBlock.classList.add('hide')
            this.offers.classList.add('hide')

        }, false)
    }

    handleResponse(response) {

        if (response.success === false) {
            this.formErrorHandler(response.message)
        } else {
            this.cleanAddress = response.data.cleanAddress ?? null
            this.formSuccessHandler(response.message)
        }
    }

    summaryTemplate() {
        return `<div class="form__response-row">
             <dl class="summary">
                <dt class="summary__label">OTO-ID</dt>
                <dd class="summary__text">${this.otoId.length ? this.otoId : '-'}</dd>    
            </dl>
        </div>
         <div class="form__response-row">
          <dl class="summary">
                <dt class="summary__label">${this.element.dataset.addressText}</dt>
                <dd class="summary__text">
                    ${this.getAddresss()}
                </dd>    
            </dl>
        </div>`
    }

    getAddresss() {
        if (this.cleanAddress) {
            return `${this.cleanAddress.streetname} ${this.cleanAddress.house_number}${this.cleanAddress.house_number_suffix}<br>${this.cleanAddress.zip} ${this.cleanAddress.city}`;
        }
        // fallback, show data from fields
        return `${this.addressField.value} ${this.numberField.value} <br>${this.selectedCity}`;
    }

    formErrorHandler(errorMessage, showText) {
        this.form.classList.add('hide')

        this.feedbackBlock.innerText = errorMessage
        this.summaryBlock.innerHTML = this.summaryTemplate()
        this.responseBlock.classList.remove('hide')

    }

    formSuccessHandler(successMessage) {
        this.form.classList.add('hide')

        this.responseBlock.classList.remove('hide')
        this.feedbackBlock.innerText = successMessage
        this.summaryBlock.innerHTML = this.summaryTemplate()

        this.offers.classList.remove('hide')
    }

    selectInit() {
        this.citiesSelectField.addEventListener('change', (evt) => {
            this.selectedCity = evt.currentTarget.value
            this.addressField.value = ''
            this.selectedAddress = null
            this.numberField.value = ''
        })
    }

    splitHouseNumber(houseNumber) {

        if (!houseNumber) {
            return {};
        }

        const matches = houseNumber.match(/^(\d+)(\D*)$/);

        if (matches) {
            return {
                house_number: matches[1],
                house_number_suffix: matches[2] || ''
            }
        }
    }

}


const internetAvailabilityModule = document.querySelector('.internet-availability-check__wrapper');
new InternetAvailability(internetAvailabilityModule)